import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL + "monitoring/";

export const getAgentMonitoring = async (agentID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}getagentmonitoring?agentid=${agentID}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getAgentMonitoring: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getCallMonitoring = async (agentID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}getcallmonitoring?agentid=${agentID}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getCallMonitoring: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getFieldAgentMonitoring = async (agentID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}getfieldagentmonitoring`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getFieldAgentMonitoring: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getGeocode = async (latitude, longitude) => {
  try {
    const response = await axios.get(
      `https://api-bdc.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=id`
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getGeocode: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getIVRDevice = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(`${apiUrl}getivrdevice`, config);

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getIVRDevice: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getIVRMonitoring = async (IVRDeviceID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}getivrmonitoring?ivrdeviceid=${IVRDeviceID}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getIVRMonitoring: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getACDMonitoring = async (ACDDeviceID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}getacdmonitoring${ACDDeviceID ? `?acddeviceid=${ACDDeviceID}` : ``}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getACDMonitoring: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const monitoringAction = async (type, destinationExt, sourceExt) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}monitoringAction?type=${type}&extdest=${destinationExt}&agentext=${sourceExt}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API monitoringAction: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getActiveAgent = async (agentID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}getactiveagent?agentid=${agentID}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getActiveAgent: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getACDDevice = async (clientID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}getacddevice${clientID ? `?clientid=${clientID}` : ``}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getACDDevice: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
            ? error.message
            : "Failed!"),
    };
  }
};
